import React, { useContext } from "react";
import { IntlContext } from "context";
import { Wrench } from "lucide-react";
import { getListingDetailLabelKeys, type ListingCategoryDetail, type ListingDetailKind } from "./types";

interface Props {
    detail: ListingCategoryDetail;
    kind: ListingDetailKind;
}

const Handiwork: React.FC<Props> = ({ detail, kind }) => {
    const intl = useContext(IntlContext);
    const { data } = detail;
    const labels = getListingDetailLabelKeys(kind);

    return (
        <>
            {labels.equipment && <label>{intl.formatMessage(labels.equipment)}</label>}
            <Wrench size={16} aria-hidden="true" />
            <span>
                {Number(data.bring_tools) === 1
                    ? intl.formatMessage(labels.bringYes)
                    : intl.formatMessage(labels.bringNo)}
            </span>
        </>
    );
};

export default Handiwork;
